module.exports = __webpack_public_path__ + "img/绿幕抠图--支持定制.89a571d5.png";